export default "__VITE_ASSET__65e433d1__"